import axiosInstance from '../../api/axiosInstance'

export interface CancelEnviaRequest {
  numero_guia: string
  usuario_online: string
  fec_captura: string
  num_documentos: string
}

export interface CancelEnviaResponse {
  success: boolean
  message: string
  data?: any
}

export const cancelarGuiaEnvia = async (requestData: CancelEnviaRequest): Promise<CancelEnviaResponse> => {
  const token = localStorage.getItem('accessToken')
  if (!token) {
    throw new Error('Error de autenticación')
  }

  // Validar campos requeridos
  if (!requestData.numero_guia || !requestData.usuario_online || !requestData.fec_captura) {
    throw new Error('Datos incompletos. Se requieren: numero_guia, usuario_online y fec_captura')
  }

  console.log('🚫 Cancelando guía con Envía (Colvanes):', JSON.stringify(requestData, null, 2))

  const response = await axiosInstance.post('/guias/anular', requestData, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  })

  return response.data
}
